var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.30371C4.13438 1.30371 1 4.43809 1 8.30371C1 12.1693 4.13438 15.3037 8 15.3037C11.8656 15.3037 15 12.1693 15 8.30371C15 4.43809 11.8656 1.30371 8 1.30371ZM11.0234 6.01777L7.73281 10.5803C7.68682 10.6445 7.62619 10.6968 7.55595 10.7329C7.48571 10.7689 7.40787 10.7878 7.32891 10.7878C7.24994 10.7878 7.17211 10.7689 7.10186 10.7329C7.03162 10.6968 6.97099 10.6445 6.925 10.5803L4.97656 7.88027C4.91719 7.79746 4.97656 7.68184 5.07812 7.68184H5.81094C5.97031 7.68184 6.12187 7.7584 6.21562 7.88965L7.32812 9.4334L9.78438 6.02715C9.87813 5.89746 10.0281 5.81934 10.1891 5.81934H10.9219C11.0234 5.81934 11.0828 5.93496 11.0234 6.01777Z",
    fill: "#2ADFA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassChecked);
export default __webpack_public_path__ + "static/media/pass-checked.a473f6e700b839ee9e636815f9c539aa.svg";
export { ForwardRef as ReactComponent };